/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledNav = styled.ul`
  display: flex;
  flex: 1;
  li {
    white-space: nowrap;
    > a {
      padding: 0 31px;
      display: inline-block;
      font-size: 16px;
      color: #fff;
      height: 56px;
      line-height: 56px;
    }

    &:hover {
      background: #44a2e6;
    }

    &.active {
      background: #1283d5;
    }
  }
`;
